import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { LabelM } from '@sorare/core/src/atoms/typography';

import {
  ItemImgContainer,
  ItemInfosContainer,
} from '#src/components/ItemPreview/ui.tsx';
import { ItemRoot } from '#src/components/mySorare/common/ui.ts';
import { CardDescription } from '#src/components/token/CardDescription/index.tsx';
import { FlexCard } from '#src/components/token/FlexCard/index.tsx';

import { SaleDetails } from './SaleDetails/index.tsx';
import type { Sale_offer } from './__generated__/index.graphql.ts';

type Props = {
  sale: Sale_offer;
};

export const Sale = ({ sale }: Props) => {
  const card = sale.senderSide.cards[0];

  return (
    <ItemRoot>
      <ItemImgContainer>
        <FlexCard card={card} withLink />
      </ItemImgContainer>
      <ItemInfosContainer>
        <CardDescription
          card={card}
          Details={LabelM}
          detailsColor="var(--c-nd-600)"
        />
        <SaleDetails sale={sale} card={card} showFees />
      </ItemInfosContainer>
    </ItemRoot>
  );
};

Sale.fragments = {
  offer: gql`
    fragment Sale_offer on TokenOffer {
      id
      senderSide {
        id
        cards: anyCards {
          slug
          ...FlexCard_anyCard
          ...SaleDetails_anyCard
          ...CardDescription_anyCard
        }
      }
      ...SaleDetails_offer
    }
    ${FlexCard.fragments.anyCard}
    ${SaleDetails.fragments.anyCard}
    ${CardDescription.fragments.anyCard}
    ${SaleDetails.fragments.offer}
  ` as TypedDocumentNode<Sale_offer>,
};
